<template>
  <div :class="classSearch">
    <b-form @submit="onSubmit">
      <template v-if="horizontal">
        <b-row>
          <b-col sm="4">
            <label class="mr-sm-2" for="reference">Referencia</label>
            <b-form-input
              id="reference"
              v-model="filters.intReference"
              type="text"
              placeholder="Referencia"
              trim
            ></b-form-input>
          </b-col>
          <b-col sm="4">
            <label class="mr-sm-2" for="propertyType">Tipo</label>
            <b-form-select
              id="propertyType"
              v-model="filters.propertyType"
              :options="propertyTypes"
              @change="changeProperty"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-col>
          <b-col sm="4" v-if="filters.propertyType == 1">
            <label class="mr-sm-2" for="houseType">Tipo vivienda</label>
            <b-form-select
              id="houseType"
              v-model="filters.houseType"
              :options="houseTypes"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-col>
          <b-col sm="4">
            <label class="mr-sm-2" for="process">Proceso</label>
            <b-form-select
              id="process"
              v-model="filters.process"
              :options="processTypes"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-col>
          <b-col sm="4">
            <label class="mr-sm-2" for="city">Localidad</label>
            <b-form-select
              id="city"
              v-model="filters.city"
              :options="cities"
              @change="getZones"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-col>
          <b-col sm="4" v-if="filters.city">
            <label class="mr-sm-2" for="zone">Zona</label>
            <b-form-select id="zone" v-model="filters.zone" :options="zones">
              <option value>Todas</option>
            </b-form-select>
          </b-col>
          <b-col sm="4">
            <b-form-group label="Precio" label-for="price" id="price-group">
              <b-form-input
                id="minPrice"
                v-model="filters.min__price"
                type="number"
                placeholder="Mín."
                trim
              ></b-form-input>
              <b-form-input
                id="maxPrice"
                v-model="filters.max__price"
                type="number"
                placeholder="Máx."
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group label="Superficie" label-for="area" id="area-group">
              <b-form-input
                id="minArea"
                v-model="filters.min__area"
                type="number"
                placeholder="Mín."
                trim
              ></b-form-input>
              <b-form-input
                id="maxArea"
                v-model="filters.max__area"
                type="number"
                placeholder="Máx."
                trim
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="filters.propertyType == 1">
            <b-form-group
              label="Mín habitaciones"
              label-for="minBedrooms"
              id="minBedrooms-group"
            >
              <b-form-select
                id="minBedrooms"
                v-model="filters.min__bedrooms"
                :options="bedroomsOptions"
                value
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="filters.propertyType == 1">
            <b-form-group label="Garaje" label-for="garage" id="garage-group">
              <b-form-select
                id="garage"
                v-model="filters.garage"
                :options="yesnoOptions"
              >
                <option value>Todos</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="filters.propertyType == 1">
            <b-form-group
              label="Trastero"
              label-for="storage"
              id="storage-group"
            >
              <b-form-select
                id="storage"
                v-model="filters.storage"
                :options="yesnoOptions"
              >
                <option value>Todos</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="filters.propertyType == 4">
            <b-form-group
              label="Edificable"
              label-for="buildability"
              id="buildability-group"
            >
              <b-form-select
                id="buildability"
                v-model="filters.buildability"
                value="null"
                :options="yesnoOptions"
              >
                <option value>Todos</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="filters.propertyType == 5">
            <b-form-group
              label="Acondicionado"
              label-for="conditioned"
              id="conditioned-group"
            >
              <b-form-select
                id="conditioned"
                v-model="filters.conditioned"
                value="null"
                :options="yesnoOptions"
              >
                <option value>Todos</option>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col sm="4" v-if="sharedEnabled">
            <b-form-group
              label="Compartido"
              label-for="shared"
              id="shared-group"
            >
              <b-form-select
                id="shared"
                v-model="filters.shared"
                value="null"
                :options="yesnoOptions"
              >
                <option value>Todos</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
      </template>
      <template v-if="!horizontal">
        <b-col>
          <label class="mr-sm-2" for="reference">Referencia</label>
          <b-form-input
            id="reference"
            v-model="filters.intReference"
            type="text"
            placeholder="Referencia"
            trim
          ></b-form-input>
        </b-col>
        <b-col>
          <label class="mr-sm-2" for="propertyType">Tipo</label>
          <b-form-select
            id="propertyType"
            v-model="filters.propertyType"
            :options="propertyTypes"
            @change="changeProperty"
          >
            <option value>Todos</option>
          </b-form-select>
        </b-col>
        <b-col v-if="filters.propertyType == 1">
          <label class="mr-sm-2" for="houseType">Tipo vivienda</label>
          <b-form-select
            id="houseType"
            v-model="filters.houseType"
            :options="houseTypes"
          >
            <option value>Todos</option>
          </b-form-select>
        </b-col>
        <b-col>
          <label class="mr-sm-2" for="process">Proceso</label>
          <b-form-select
            id="process"
            v-model="filters.process"
            :options="processTypes"
          >
            <option value>Todos</option>
          </b-form-select>
        </b-col>
        <b-col>
          <label class="mr-sm-2" for="city">Localidad</label>
          <b-form-select
            id="city"
            v-model="filters.city"
            :options="cities"
            @change="getZones"
          >
            <option value>Todos</option>
          </b-form-select>
        </b-col>
        <b-col v-if="filters.city">
          <label class="mr-sm-2" for="zone">Zona</label>
          <b-form-select id="zone" v-model="filters.zone" :options="zones">
            <option value>Todas</option>
          </b-form-select>
        </b-col>
        <b-col>
          <b-form-group label="Precio" label-for="price" id="price-group">
            <b-form-input
              id="minPrice"
              v-model="filters.min__price"
              type="number"
              placeholder="Mín."
              trim
            ></b-form-input>
            <b-form-input
              id="maxPrice"
              v-model="filters.max__price"
              type="number"
              placeholder="Máx."
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Superficie" label-for="area" id="area-group">
            <b-form-input
              id="minArea"
              v-model="filters.min__area"
              type="number"
              placeholder="Mín."
              trim
            ></b-form-input>
            <b-form-input
              id="maxArea"
              v-model="filters.max__area"
              type="number"
              placeholder="Máx."
              trim
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col v-if="filters.propertyType == 1">
          <b-form-group
            label="Mín habitaciones"
            label-for="minBedrooms"
            id="minBedrooms-group"
          >
            <b-form-select
              id="minBedrooms"
              v-model="filters.min__bedrooms"
              value="null"
              :options="bedroomsOptions"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="filters.propertyType == 1">
          <b-form-group label="Garaje" label-for="garage" id="garage-group">
            <b-form-select
              id="garage"
              v-model="filters.garage"
              value="null"
              :options="yesnoOptions"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="filters.propertyType == 1">
          <b-form-group label="Trastero" label-for="storage" id="storage-group">
            <b-form-select
              id="storage"
              v-model="filters.storage"
              value="null"
              :options="yesnoOptions"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="filters.propertyType == 4">
          <b-form-group
            label="Edificable"
            label-for="buildability"
            id="buildability-group"
          >
            <b-form-select
              id="buildability"
              v-model="filters.buildability"
              value="null"
              :options="yesnoOptions"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="filters.propertyType == 5">
          <b-form-group
            label="Acondicionado"
            label-for="conditioned"
            id="conditioned-group"
          >
            <b-form-select
              id="conditioned"
              v-model="filters.conditioned"
              value="null"
              :options="yesnoOptions"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col v-if="sharedEnabled">
          <b-form-group label="Compartido" label-for="shared" id="shared-group">
            <b-form-select
              id="shared"
              v-model="filters.shared"
              value="null"
              :options="yesnoOptions"
            >
              <option value>Todos</option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </template>
      <b-col style="text-align:center">
        <button type="submit" class="btn btn-personalized btn-primary">
          Buscar
        </button>
      </b-col>
    </b-form>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";

const [AddressRepository] = RepositoryFactory.bulkGet(["address"]);

export default {
  name: "Search",
  props: {
    horizontal: Boolean,
  },
  data() {
    return {
      filters: {},
      cities: [],
      zones: [],
      propertyTypes: [
        { text: "Viviendas", value: 1 },
        { text: "Edificios", value: 2 },
        { text: "Garajes", value: 3 },
        { text: "Fincas", value: 4 },
        { text: "Locales", value: 5 },
        { text: "Oficinas", value: 6 },
        { text: "Almacen", value: 7 },
        { text: "Nave Industrial", value: 8 },
      ],
      houseTypes: [
        { text: "Casa", value: 1 },
        { text: "Chalet", value: 2 },
        { text: "Dúplex", value: 3 },
        { text: "Ático", value: 4 },
        { text: "Piso", value: 5 },
        { text: "Apartamento", value: 6 },
        { text: "Estudio", value: 7 },
        { text: "Casa adosada", value: 8 },
        { text: "Chalet adosado", value: 9 },
        { text: "Otro", value: 10 },
      ],
      processTypes: [],
      basicProcess: [
        { text: "Alquiler", value: 1 },
        { text: "Venta", value: 2 },
      ],
      yesnoOptions: [{ text: "Si", value: 1 }, { text: "No", value: 0 }],
      bedroomsOptions: [
        { text: "1", value: "1" },
        { text: "2", value: "2" },
        { text: "3", value: "3" },
        { text: "4 o más", value: "4" },
      ],
      classSearch: "",
    };
  },
  computed: {
    sharedEnabled: function() {
      return (
        Boolean(process.env.VUE_APP_PROCESS_SHARED_ENABLED) &&
        this.$route.path === "/catalogo"
      );
    },
    searchPathName: function() {
      return this.$route.path === "/catalogo" ? "catalogue" : "search";
    },
  },
  created() {
    this.filters = {
      ...this.getRouteParams(),
      ...this.$route.query,
    };
    this.getCities();
    this.getZones();
    this.setBasicData();
  },
  watch: {
    $route() {
      this.filters = {
        ...this.getRouteParams(),
        ...this.$route.query,
      };
    },
  },
  methods: {
    getRouteParams() {
      const actualRoute = this.$route.matched.filter(
        ({ path }) => path === this.$route.path
      );
      if (
        actualRoute &&
        actualRoute[0] &&
        actualRoute[0].props &&
        actualRoute[0].props.default &&
        actualRoute[0].props.default.params
      ) {
        return actualRoute[0].props.default.params;
      }
      return {};
    },
    setBasicData() {
      this.processTypes = this.basicProcess;
      if (this.horizontal) {
        this.classSearch = "search horizontal";
      } else {
        this.classSearch = "search vertical";
      }
    },
    changeProperty() {
      if (this.filters.propertyType == 1) {
        this.processTypes = [
          { text: "Alquiler", value: 1 },
          { text: "Venta", value: 2 },
          { text: "Alquiler con opción a compra", value: 3 },
        ];
      } else if (this.filters.propertyType == 5) {
        this.processTypes = [
          { text: "Alquiler", value: 1 },
          { text: "Venta", value: 2 },
          { text: "Traspaso", value: 4 },
        ];
      } else {
        this.processTypes = this.basicProcess;
      }

      if (this.filters.process > 2) {
        this.filters.process = "";
      }
    },
    async getCities() {
      const { data } = await AddressRepository.getCities();
      this.cities = data;
    },
    async getZones() {
      this.filters.zone = "";
      this.zones = [];
      if (this.filters.city != "") {
        const { data } = await AddressRepository.getZonesByCity(
          this.filters.city
        );
        this.zones = data;
      } else {
        const { data } = await AddressRepository.getZones();
        this.zones = data;
      }
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.$router.push({ name: this.searchPathName, query: this.filters });
    },
  },
};
</script>

<style lang="scss">
[type="number"] {
  width: 50% !important;
  display: initial;
}

.search {
  color: #fff;
  background-color: rgba(110, 147, 96, 0.8);
  border-radius: 5px;
}

.search.horizontal {
  padding: 30px;
}

.search.vertical {
  padding: 10px;
}

.btn-personalized.btn-primary {
  background-color: #fff;
  color: #6e9360;
  width: 80%;
  border: 2px solid #fff;

  &:hover {
    color: #fff;
    background-color: #6e9360;
  }
}
</style>
